import { LicenseManager } from 'ag-grid-enterprise';
import { logger } from './logger';
import { retrieveParameter } from './aws/parameterStore';

/**
 * Configure AG Grid Enterprise license
 * This function retrieves the license key from AWS Parameter Store and sets it for AG Grid
 */
export const configureAgGridLicense = async (): Promise<void> => {
  try {
    // Retrieve the license key from Parameter Store
    const licenseKey = await retrieveParameter('/verity/fe/ag-grid-license');

    if (!licenseKey) {
      logger.error('AG Grid license key not found in Parameter Store');
      return;
    }

    // Set the license key for AG Grid Enterprise
    LicenseManager.setLicenseKey(licenseKey);

    logger.info('AG Grid Enterprise license configured successfully');
  } catch (error) {
    logger.error('Failed to configure AG Grid license:', { error });
    // Don't throw error to prevent app from crashing if license config fails
  }
};
